import moment from 'moment';
import ConverterClass from '../../utils/converter';

class Converter extends ConverterClass {
    _server2Client = (item = {}) => ({});
}

export default new Converter();